// extracted by mini-css-extract-plugin
export default {"root":"price-field-module_root-b3pN0"};